import clsx from "clsx";

import HamburgerIcon from "@ui/components/icon/HamburgerIcon";
import { useNavigationContext } from "@ui/context/navigation-context";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

import * as styles from "./HamburgerButton.css";

interface Props {
  monochrome?: boolean;
  iconClassName?: string;
}

function HamburgerButton(props: Props) {
  const analytics = useAnalytics();
  const { openDrawer, drawerId } = useNavigationContext();
  const handleMoreBtnClick = () => {
    openDrawer();
    analytics?.emit({
      event: "navigation_click",
      navigation_click: { name: "more button" },
    });
  };
  return (
    <button
      onClick={handleMoreBtnClick}
      className={styles.moreButton}
      aria-controls={drawerId}
      aria-label="Open Drawer"
    >
      <HamburgerIcon
        className={clsx(
          styles.moreIcon,
          props.monochrome && styles.monochrome,
          props.iconClassName,
        )}
      />
    </button>
  );
}

export default HamburgerButton;
